import type { FlagCode } from '@shared/components/Flag/codes'

/**
 * Keep raw jurisdiction values in a side-effect-free module.
 * `env.ts` validates eagerly at import time, so schema/tests/client-safe code
 * must import these constants from here instead of pulling in env validation.
 */
export const jurisdictions = ['at', 'de', 'eu', 'ro'] as const

export type JurisdictionCode = (typeof jurisdictions)[number]

/** The GesetzeFinden deployments. Each publishes its own jurisdiction plus EU. */
export const gesetzeFindenSites = ['at', 'de'] as const

export type GesetzeFindenSite = (typeof gesetzeFindenSites)[number]

/** The legislative radar and its chat analyse AT and EU law for now. */
export const legislativeRadarJurisdictions = ['at', 'eu'] as const

export type LegislativeRadarJurisdiction =
  (typeof legislativeRadarJurisdictions)[number]

export const jurisdictionMetadata = {
  at: { flagCode: 'at', labelKey: 'jurisdictionAT' },
  de: { flagCode: 'de', labelKey: 'jurisdictionDE' },
  eu: { flagCode: 'eu', labelKey: 'jurisdictionEU' },
  ro: { flagCode: 'ro', labelKey: 'jurisdictionRO' },
} as const satisfies Record<
  JurisdictionCode,
  { flagCode: FlagCode; labelKey: string }
>

export const jurisdictionOptions = jurisdictions.map((value) => ({
  value,
  ...jurisdictionMetadata[value],
}))
